import { Swiper, Pagination, Autoplay } from 'swiper';

Swiper.use([Pagination, Autoplay]);

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

      /* eslint-disable */
      var heroSwiper = new Swiper('.swiper--hero', {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
      /* eslint-enable */

      /* eslint-disable */
      var partnersSwiper = new Swiper('.swiper--partners', {
        slidesPerView: 2,
        breakpoints: {
          480: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        spaceBetween: 20,
        loop: true,
        pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      });
      /* eslint-enable */

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js